import { tmrOperationController } from 'tmr/controllers/operation/operation'

/**
 * Checklist Operation utilities, used by classes extending {@link tmrChecklistOperationController}
 *
 * @type {ngService}
 */
export class tmrChecklistOperationController extends tmrOperationController {
  static ngType = 'controller'

  constructor(
    debounce,
    $mdDialog,
    TmrToast,
    TmrMovementHelper,
    TmrMovementByUpcHelper,
    TmrOperationHelper,
    Checklist,
    TmrChecklistNotFoundError
  ) {
    'ngInject'
    super($mdDialog, TmrToast, TmrMovementHelper, TmrOperationHelper)
    Object.assign(this, {
      debounce,
      TmrToast,
      TmrMovementHelper,
      TmrMovementByUpcHelper,
      Checklist,
      TmrChecklistNotFoundError,
    })
  }

  initVars() {
    super.initVars()
    this.groupedItems = []
    this.itemsByExpectedUpc = []
    this.itemsCount = {}
    this.confirmDisabled = false
    this.buildGroupsDebounce = this.debounce(150, details =>
      this.buildGroups(details)
    )
    if (this.checklist) this.buildGroups({})
  }

  /**
   * Groups read items by upc + unexpected.
   *
   * @param {object=} details parsed MovementInbound.status response
   */
  buildGroups(details) {
    if (this.checklist) {
      if (this.checklist.items) {
        this.itemsByExpectedUpc =
          this.TmrMovementHelper.groupitemsByExpectedUpc(
            details,
            this.antenna,
            this.checklist.items
          )
        this.itemsCount = this.TmrMovementHelper.countItems(
          this.itemsByExpectedUpc
        )
      } else if (this.checklist.upcs) {
        this.itemsByExpectedUpc =
          this.TmrMovementByUpcHelper.groupitemsByExpectedUpc(
            details,
            this.antenna,
            this.checklist.upcs
          )
        this.itemsCount = this.TmrMovementByUpcHelper.countItems(
          this.itemsByExpectedUpc
        )
      }
    } else
      this.groupedItems = this.TmrMovementHelper.groupByUpcStatus(
        details,
        this.antenna
      )
    this.confirmDisabled = this.isConfirmDisabled()
  }

  isConfirmDisabled() {
    if (this.checklist) {
      if (this.checklist.items)
        return !this.TmrMovementHelper.isChecklistConfirmable(
          this.itemsByExpectedUpc
        )
      else if (this.checklist.upcs)
        return !this.TmrMovementByUpcHelper.isChecklistConfirmable(
          this.itemsByExpectedUpc
        )
    }
    return false
  }

  onChecklistChange(isOn) {
    this.checklistEnable = isOn
    this.checklist = null
    this.initVars()
  }

  onPackageCodeChange(isOne, value, event) {
    if (isOne && value && event.key == 'Enter') {
      this.Checklist.query({
        packageCode: value,
        confirmed: false,
      }).$promise.then(res => {
        if (res.length > 0) {
          this.checklist = res[0]
          this.buildGroups({})
        } else this.TmrToast.exception(new this.TmrChecklistNotFoundError())
      })
    } else this.checklist = null
  }
}
